// src/app/pipes/slugify.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slugify',
  pure: true
})
export class SlugifyPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLen?: number): string {
    if (!value) return '';

    // 1) normalize unicode (é -> e, but Arabic stays as is)
    let slug = value.normalize('NFKC');

    // 2) normalize various dash characters to simple hyphen
    slug = slug.replace(/[\u2012\u2013\u2014\u2015]/g, '-');

    // 3) keep English letters, numbers, Arabic letters, spaces, and hyphens
    slug = slug.replace(/[^0-9a-zA-Z\u0600-\u06FF\s-]/g, ' ');

    // 4) trim, collapse whitespace -> single hyphen
    slug = slug.trim().toLowerCase();
    slug = slug.replace(/\s+/g, '-');

    // 5) collapse multiple hyphens
    slug = slug.replace(/-+/g, '-');

    // 6) optional max length
    if (typeof maxLen === 'number' && maxLen > 0) {
      slug = slug.substring(0, maxLen).replace(/-+$/g, '');
    }

    // 7) remove leading/trailing hyphens
    slug = slug.replace(/^-+|-+$/g, '');

    return slug;
  }
}
